import { CSSProperties } from 'react'

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg' | number
  className?: string
  style?: CSSProperties
  color?: string
}

const sizeMap = { sm: 16, md: 24, lg: 40 }

export default function Spinner({ size = 'md', className = '', style, color }: SpinnerProps) {
  const px = typeof size === 'number' ? size : sizeMap[size]
  return (
    <svg
      width={px}
      height={px}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ animation: 'spin 0.75s linear infinite', color, ...style }}
      aria-label="Loading"
    >
      <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" opacity="0.25" />
      <path
        d="M12 3a9 9 0 0 1 9 9"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}
